"use client"

import { useState, useEffect } from "react"
import ModernSidebar from "./admin_sidebar"
import ModernDashboard from "./modern-dashboard"
import ModernHeader from "./modern-header"
import axios from "axios"
import { isGuest } from "../utils/isGuest"

export default function ModernMainDashboard() {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const [fullName, setFullName] = useState("")
  const [email, setEmail] = useState("")

  const toggleSidebar = () => setSidebarOpen((prev) => !prev)

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768
      setIsMobile(mobile)

      if (mobile) {
        setSidebarOpen(false)
      }
    }

    handleResize()
    window.addEventListener("resize", handleResize)
    window.addEventListener("orientationchange", () => {
      setTimeout(handleResize, 100)
    })

    return () => {
      window.removeEventListener("resize", handleResize)
      window.removeEventListener("orientationchange", handleResize)
    }
  }, [])

 useEffect(() => {
  const fetchProfile = async () => {
    try {

      // ⛔ If guest, do NOT call API — just set empty demo values
      if (isGuest()) {
        setFullName("Guest User");
        setEmail("guest@example.com");
        return;
      }

      const startupId = localStorage.getItem("startupId");
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/startups/${startupId}`
      );

      setFullName(response.data.fullName);
      setEmail(response.data.email); // already correct
    } catch (error) {
      console.error("Error fetching startup profile:", error);
    }
  };

  fetchProfile();
}, []);


  return (
    <div className="flex h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-50/30 overflow-hidden">
      {/* Sidebar */}
      <ModernSidebar
        isOpen={sidebarOpen}
        toggleSidebar={toggleSidebar}
        isMobile={isMobile}
        fullName={fullName}
        email={email}
      />

      {/* Main Content */}
      <div
        className={`flex flex-col flex-1 transition-all duration-300 min-h-0 ${!isMobile ? "ml-16 sm:ml-18 md:ml-20 lg:ml-20 xl:ml-20" : "ml-0"
          }`}
      >
        {/* Header */}
        <ModernHeader toggleSidebar={toggleSidebar} isMobile={isMobile} />

        {/* Dashboard Content */}
        <div className="flex-1 p-4 xs:p-6 sm:p-8 overflow-y-auto min-h-0">
          <ModernDashboard />
        </div>
      </div>
    </div>
  )
}
